import axios from '../../plugins/axios';

export interface PermissionResponse {
  message: string;
  data: {
    permissions: string[];
  };
}

export const getMyPermissions = async (): Promise<string[]> => {
  try {
    const response = await axios.get<PermissionResponse>('/admin/profile/permissions');
    return response.data.data.permissions;
  } catch (error) {
    console.error('Error fetching permissions:', error);
    return [];
  }
};

export const hasPermission = (userPermissions: string[], requiredPermission: string): boolean => {
  return userPermissions.includes(requiredPermission);
};

export const hasAnyPermission = (userPermissions: string[], requiredPermissions: string[]): boolean => {
  return requiredPermissions.some(permission => userPermissions.includes(permission));
};
